import { Box, Button } from '@mui/material'
import useFetchOrganizacion from 'common/hooks/useFetchOrganizacion'
import { useEffect, useState } from 'react'
import PurchaseOrdersFilters from '../components/PurchaseOrdersDataFilters'
import PurchaseOrdersTable from '../components/PurchaseOrdersTable'
import useFetchPurchaseOrders from '../hooks/useFetchPurchaseOrders'

const PurchaseOrders = () => {
  const [serie, setSerie] = useState('')
  const [numero, setNumero] = useState('')
  const [orgCompras, setOrgCompras] = useState('')
  const [fechaPedidoDesde, setFechaPedidoDesde] = useState('')
  const [fechaPedidoHasta, setFechaPedidoHasta] = useState('')
  const [ordenarPor, setOrdenarPor] = useState('')
  const [page, setPage] = useState(1)

  const [purchaseOrders, setPurchaseOrders] = useState([])

  const { response, loading, numeroRegistros } = useFetchPurchaseOrders({
    serie,
    numero,
    orgCompras,
    fechaPedidoDesde,
    fechaPedidoHasta,
    ordenarPor,
    page,
  })

  const { response: organizaciones, loading: selector_loading } = useFetchOrganizacion()

  useEffect(() => {
    if (!selector_loading && organizaciones?.length === 1) {
      setOrgCompras(organizaciones[0].codigo_org_compras)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizaciones])

  useEffect(() => {
    if (!loading) {
      if (page === 1) {
        setPurchaseOrders(response)
      } else {
        setPurchaseOrders([...purchaseOrders, ...response])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const updateHasSelectedLines = (id) => {
    setPurchaseOrders((prevPurchaseOrders) =>
      prevPurchaseOrders.map((order) =>
        order.id === id ? { ...order, has_selected_lines: !order.has_selected_lines } : order,
      ),
    )
  }

  const checkHasSelectedLines = (purchaseOrderId, purchaseOrderLines) => {
    if (purchaseOrderLines?.length > 0) {
      const lines_selected = purchaseOrderLines?.some((line) => line.selected === true)

      setPurchaseOrders((prevPurchaseOrders) =>
        prevPurchaseOrders?.map((order) =>
          order.id === purchaseOrderId ? { ...order, has_selected_lines: lines_selected } : order,
        ),
      )
    }
  }

  const handleChangeFilters = (
    newSerie,
    newNumero,
    newOrgCompras,
    newFechaPedidoDesde,
    newFechaPedidoHasta,
  ) => {
    if (
      serie !== newSerie ||
      numero !== newNumero ||
      orgCompras !== newOrgCompras ||
      fechaPedidoDesde !== newFechaPedidoDesde ||
      fechaPedidoHasta !== newFechaPedidoHasta
    ) {
      setPage(1)
      setPurchaseOrders([])

      setSerie(newSerie)
      setNumero(newNumero)
      setOrgCompras(newOrgCompras)
      setFechaPedidoDesde(newFechaPedidoDesde)
      setFechaPedidoHasta(newFechaPedidoHasta)
    }
  }

  const handleSortByChange = (newOrdernarPor) => {
    setPage(1)
    setOrdenarPor(newOrdernarPor)
  }

  return (
    <Box>
      <PurchaseOrdersFilters
        loader={loading}
        handleClick={handleChangeFilters}
        handleSortByChange={handleSortByChange}
        seletor_loading={selector_loading}
        purchasingOrganizations={organizaciones}
      />
      <PurchaseOrdersTable
        loader={loading}
        purchaseOrders={purchaseOrders}
        handleUpdateSelectedLines={updateHasSelectedLines}
        handleCheckSelectedLines={checkHasSelectedLines}
        hidePurchaseOrg={organizaciones?.length === 1}
        purchasingOrganizations={organizaciones}
      />
      {Math.ceil(parseInt(numeroRegistros) / 12) > page && (
        <Button
          disabled={loading}
          onClick={() => {
            setPage(page + 1)
          }}
          sx={{ px: 5, mt: 2, mx: 'auto', display: 'block' }}
          variant="outlined"
        >
          Cargar Más
        </Button>
      )}
    </Box>
  )
}

export default PurchaseOrders
